/* istanbul ignore file - better tested visually */

import { classNames } from '@partful/shared/lib/classNames';
import { useGoogleAnalytics } from '@partful/shared/lib/hooks/useGoogleAnalytics';
import React, { ComponentProps } from 'react';
import { NavLink, NavLinkProps } from 'react-router-dom';
import styles from './Card.module.scss';

export function Card({ className, children, ...rest }: ComponentProps<'div'>) {
  return (
    <div className={classNames(styles.card, className)} {...rest}>
      {children}
    </div>
  );
}

export function NavCard({
  name,
  className,
  onClick,
  children,
  ...rest
}: { name?: string } & ComponentProps<'a'> & NavLinkProps) {
  const { sendEvent } = useGoogleAnalytics();

  const onClickWithAnalytics = (mouseEvent: React.MouseEvent<HTMLAnchorElement>): void => {
    onClick?.(mouseEvent);

    if (name) {
      sendEvent(name);
    }
  };

  return (
    <NavLink className={classNames(styles.card, className)} onClick={onClickWithAnalytics} {...rest}>
      {children}
    </NavLink>
  );
}

export function CardMedia({ className, children, ...rest }: ComponentProps<'div'>) {
  return (
    <div className={classNames(styles.media, className)} {...rest}>
      {children}
    </div>
  );
}

export function CardContent({ className, children, ...rest }: ComponentProps<'div'>) {
  return (
    <div className={classNames(styles.label, className)} {...rest}>
      {children}
    </div>
  );
}
